import { addons } from "./page-translations/addons";
import { adjustCredit } from "./page-translations/adjustCredit";
import { applicationSettings } from "./page-translations/applicationSettings";
import { chooseAddons } from "./page-translations/chooseAddons";
import { choosePackage } from "./page-translations/choosePackage";
import { common } from "./page-translations/common";
import { contactInfo } from "./page-translations/contactInfo";
import { dashboardPage } from "./page-translations/dashboard";
import { errorTranslations } from "./page-translations/error";
import { fullAccessUsersPage } from "./page-translations/fullAccessUserPage";
import { header } from "./page-translations/header";
import { kyc } from "./page-translations/kyc";
import { loginPage } from "./page-translations/loginPage";
import { modalTranslations } from "./page-translations/modals";
import { navbar } from "./page-translations/navbar";
import { newCompany } from "./page-translations/new-company";
import { pageFooter } from "./page-translations/pageFooter";
import { signPageTranslations } from "./page-translations/signPage";
import { summaryPage } from "./page-translations/summaryPage";
import { validation } from "./page-translations/validation";

export const texts = {
	appTitle: {
		sv: "Företagsbanken - bli kund | Svea Bank",
	},
	pageFooter: {
		...pageFooter,
	},
	error: {
		...errorTranslations,
	},
	signPage: {
		...signPageTranslations,
	},
	modals: {
		...modalTranslations,
	},
	choosePackage: {
		...choosePackage,
	},
	loginPage: {
		...loginPage,
	},
	dashboardPage: {
		...dashboardPage,
	},
	chooseAddons: {
		...chooseAddons,
	},
	adjustCredit: {
		...adjustCredit,
	},
	kyc: {
		...kyc,
	},
	contactInfo: {
		...contactInfo,
	},
	fullAccessUsersPage: {
		...fullAccessUsersPage,
	},
	summaryPage: {
		...summaryPage,
	},
	addons: {
		...addons,
	},
	header: {
		...header,
	},
	applicationSettings: {
		...applicationSettings,
	},
	navbar: {
		...navbar,
	},
	common: {
		...common,
	},
	validation: {
		...validation,
	},
	newCompany: {
		...newCompany,
	},
};
